export function isTag(
	input: Element | undefined,
	tags: ReadonlyArray< string >
): boolean {
	let el: Element | null | undefined = input;
	do {
		if ( el && tags.includes( el.nodeName ) ) {
			return true;
		}
		el = el?.parentElement;
	} while ( !! el );
	return false;
}

export function isSelectorTag(
	selector: string,
	tags: ReadonlyArray< string >
): boolean {
	const parts = selector.split( ' ' );
	const last = parts[ parts.length - 1 ] || '';
	const tag = last.toUpperCase().replace( /[^A-Z].*$/, '' );
	return tags.includes( tag );
}
